"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.afterDateTime = exports.nowDateTime = void 0;
var moment_1 = __importDefault(require("moment"));
// desired format is 	2020-12-09T01:45:30Z
var nowDateTime = function () { return (0, moment_1.default)().format(moment_1.default.HTML5_FMT.DATETIME_LOCAL_SECONDS) + 'Z'; };
exports.nowDateTime = nowDateTime;
var afterDateTime = function (left, right, granularity) {
    if (granularity === void 0) { granularity = 'seconds'; }
    return (0, moment_1.default)(left).isAfter(right, granularity);
};
exports.afterDateTime = afterDateTime;
//# sourceMappingURL=DateTimeUtils.js.map